import { useQuery } from 'react-query';
import { useService } from 'shared/providers';

export function useQueryApprovers() {
  const { quoteService } = useService();
  const { data, isLoading, isFetching } = useQuery<string[], Error>(['quote-approvers'], () =>
    quoteService.getQuoteApprovers()
  );

  return { approvers: data ?? [], isLoading, isFetching } as const;
}
